import SubmitBox from '../components/submitBox'

const component = {
  install: function (Vue) {
    //弹窗
    Vue.component('submit-box', SubmitBox)
  }
}
// 导出该组件
export default component



// WEBPACK FOOTER //
// ./src/plugins/install.js